import { render, staticRenderFns } from "./navBtn.vue?vue&type=template&id=6ac17230&"
import script from "./navBtn.vue?vue&type=script&lang=js&"
export * from "./navBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports